/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import LoginPage from '@/components/LoginPage'
import Login2Page from '@/components/Login2Page'
import LogoutPage from '@/components/LogoutPage'
import StokPage from '@/components/StokPage'
import CihazlarPage from '@/components/CihazlarPage'
import ArizaKayitPage from '@/components/ArizaKayitPage'
import ArizaKayit_v2 from '@/components/ArizaKayit_v2'
import SarfMalzemeleriPage from '@/components/SarfMalzemeleriPage'
import UretimPage from '@/components/UretimPage'
import UretimlerPage from '@/components/UretimlerPage'
import UrunlerPage from '@/components/UrunlerPage'
import UrunOlusturPage from '@/components/UrunOlusturPage'
import CikislarPage from '@/components/CikislarPage'
import Cikislarv2Page from '@/components/CikislarV2Page'
import GonderiYapPage from '@/components/GonderiYapPage'
import SahaOperasyonPage from '@/components/SahaOperasyonPage'
import SOKayitEkle from '@/components/SOKayitEklePage'
import InvoiceWaybillPage from '@/components/InvoiceWaybillPage'
import SerialPage from '@/components/SerialPage'
import NotesPage from '@/components/NotesPage'
import OperPointsPage from '@/components/OperPointsPage'
import DebugPage from '@/components/DebugPage'
import SetlerPage from '@/components/SetlerPage'
import HatlarPage from '@/components/YeniHatlarPage'
import RetailerSubscriptionPage from '@/components/RetailerSubscriptionPage'
import ProfilePage from '@/components/ProfilePage'
import ServiceReservationsPage from '@/components/ServiceReservationsPage'
import TekliflerPage from '@/components/TekliflerPage'
import TeklifDetayPage from '@/components/TeklifDetayPage'
import AranmaTalepleriPage from '@/components/AranmaTalepleriPage'
import UetdsVehicles from '@/components/UetdsVehicles'
import CargoTrackingPage from '@/components/CargoTrackingPage'
import UnitPricesPage from '@/components/UnitPricesPage'
import LucaCustomerCodesPage from '@/components/LucaCustomerCodesPage'
import FaturaYuklemeleriPage2 from '@/components/FaturaYuklemeleriPage2'
import FaturaYildizlariPage from '@/components/FaturaYildizlariPage'
import A1ReportLogPage from '../components/A1ReportLogPage.vue'
import DemoTalepleriPage from '../components/DemoTalepleriPage.vue'
import IccidPairsPage from '@/components/IccidPairsPage'
import CallbackPage from '@/components/CallbackPage'
import LoginRequiredPage from '@/components/LoginRequiredPage'
import Dashboard from '@/components/Dashboard'
import Paginate from 'vuejs-paginate'
import authGuard from '@/auth/guard'
import axios from 'axios'
import store from '@/store'
import DisconnectedDevicesPage from '../components/DisconnectedDevicesPage.vue'

Vue.use(Router)
Vue.component('paginate', Paginate);

let vRouter = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      beforeEnter: authGuard,
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: Login2Page,
    },
    {
      path: '/logout',
      name: 'LogoutPage',
      component: LogoutPage,
      beforeEnter: authGuard,
    },
    {
      path: '/stok',
      name: 'StokPage',
      component: StokPage,
      beforeEnter: authGuard,
    },
    {
      path: '/stok/seri-numaralar',
      name: 'SerialPage',
      component: SerialPage,
      beforeEnter: authGuard,
    },
    {
      path: '/ariza-kayitlari',
      name: 'CihazlarPage',
      component: CihazlarPage,
      beforeEnter: authGuard,
    },
    {
      path: '/ariza-kayitlari/contexts/:id',
      name: 'CihazlarPage',
      component: CihazlarPage,
      beforeEnter: authGuard,
    },
    {
      path: '/ariza-kaydi-ekle',
      name: 'ArizaKayitPage',
      component: ArizaKayitPage,
      beforeEnter: authGuard,
    },
    {
      path: '/sarf-malzemeleri',
      name: 'SarfMalzemeleri',
      component: SarfMalzemeleriPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretimler',
      name: 'Uretimler',
      component: UretimlerPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretim/hesapla/:id',
      name: 'UretimPage',
      component: UretimPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretim/urunler',
      name: 'UrunlerPage',
      component: UrunlerPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretim/setler',
      name: 'SetlerPage',
      component: SetlerPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretim/urun-olustur',
      name: 'UrunUpdatePage',
      component: UrunOlusturPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uretim/urun-olustur/:id',
      name: 'UrunUpdatePage',
      component: UrunOlusturPage,
      beforeEnter: authGuard,
    },
    {
      path: '/urun-cikislari',
      name: 'CikislarV2Page',
      component: Cikislarv2Page,
      beforeEnter: authGuard,
    },
    {
      path: '/eski-urun-cikislari',
      name: 'CikislarPage',
      component: CikislarPage,
      beforeEnter: authGuard,
    },
    {
      path: '/urun-cikislari/gonderi-yap',
      name: 'GonderiYap',
      component: GonderiYapPage,
      beforeEnter: authGuard,
    },
    {
      path: '/urun-cikislari/gonderi-yap/:id',
      name: 'GonderiYap',
      component: GonderiYapPage,
      beforeEnter: authGuard,
    },
    {
      path: '/urun-cikislari/contexts/:id',
      name: 'CikislarPage',
      component: Cikislarv2Page,
      beforeEnter: authGuard,
    },
    {
      path: '/saha-operasyon',
      name: 'SahaOperasyon',
      component: SahaOperasyonPage,
      beforeEnter: authGuard,
    },
    {
      path: '/saha-operasyon/kayit-ekle',
      name: 'SahaOperasyonKayitEkle',
      component: SOKayitEkle,
      beforeEnter: authGuard,
    },
    {
      path: '/saha-operasyon/kayit-guncelle/:id',
      name: 'SahaOperasyonKayitGuncelle',
      component: SOKayitEkle,
      beforeEnter: authGuard,
    },
    {
      path: '/fatura-onizleme/:id',
      name: 'InvoiceWaybillPage',
      component: InvoiceWaybillPage,
      beforeEnter: authGuard,
    },
    {
      path: '/notlar',
      name: 'NotesPage',
      component: NotesPage,
      beforeEnter: authGuard,
    },
    {
      path: '/montaj-noktalari',
      name: 'OperPointsPage',
      component : OperPointsPage,
      beforeEnter: authGuard,
    },
    {
      path: '/montaj-noktalari/:id',
      name: 'OperPointsPage',
      component : OperPointsPage,
      beforeEnter: authGuard,
    },
    {
      path: '/debug',
      name: 'DebugPage',
      component : DebugPage,
      beforeEnter: authGuard,
    },
    {
      path: '/hatlar',
      name: 'HatlarPage',
      component : HatlarPage,
      beforeEnter: authGuard,
    },
    {
      path: '/hatlar/iccid-pairs',
      name: 'IccidPairsPage',
      component : IccidPairsPage,
      beforeEnter: authGuard,
    },
    {
      path: '/bayii-aidat-takibi',
      name: 'BayiiAidatTakibi',
      component : RetailerSubscriptionPage,
      beforeEnter: authGuard,
    },
    {
      path: '/personel/:id',
      name: 'ProfilePage',
      component : ProfilePage,
      beforeEnter: authGuard,
    },
    {
      path: '/servis-randevulari',
      name: 'ServiceReservationsPage',
      component : ServiceReservationsPage,
      beforeEnter: authGuard,
    },
    {
      path: '/teklifler',
      name: 'TekliflerPage',
      component : TekliflerPage,
      beforeEnter: authGuard,
    },
    {
      path: '/teklif/:teklifId',
      name: 'TeklifDetayPage',
      component : TeklifDetayPage,
      beforeEnter: authGuard,
    },
    {
      path: '/aranma-talepleri',
      name: 'AranmaTalepleri',
      component : AranmaTalepleriPage,
      beforeEnter: authGuard,
    },
    {
      path: '/uetds/araclar',
      name: 'UetdsVehiclesPage',
      component : UetdsVehicles,
      beforeEnter: authGuard,
    },
    {
      path: '/kargo-takip',
      name: 'KargoTakipPage',
      component : CargoTrackingPage,
      beforeEnter: authGuard,
    },
    {
      path: '/fiyat-listesi',
      name: 'UnitPricesPage',
      component : UnitPricesPage,
      beforeEnter: authGuard,
    },
    {
      path: '/luca-kodlari',
      name: 'LucaCustomerCodesPage',
      component : LucaCustomerCodesPage,
      beforeEnter: authGuard,
    },
    {
      path: '/fatura-yuklemeleri',
      name: 'FaturaYuklemeleriPage2',
      component : FaturaYuklemeleriPage2,
      beforeEnter: authGuard,
    },
    {
      path: '/fatura-yildizlari',
      name: 'FaturaYildizlariPage',
      component : FaturaYildizlariPage,
      beforeEnter: authGuard,
    },
    {
      path: '/kesik-cihazlar',
      name: 'DisconnectedDevicesPage',
      component : DisconnectedDevicesPage,
      beforeEnter: authGuard,
    },
    {
      path: '/a1-report-log',
      name: 'A1ReportLogPage',
      component : A1ReportLogPage,
      beforeEnter: authGuard,
    },
    {
      path: '/demo-talepleri',
      name: 'DemoTalepleriPage',
      component : DemoTalepleriPage,
      beforeEnter: authGuard,
    },
    {
      path: '/callback',
      name: 'CallbackPage',
      component: CallbackPage,
    },
    {
      path: '/login_required',
      name: 'LoginRequiredPage',
      component: LoginRequiredPage
    }
  ]
})

/*
vRouter.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth == true && localStorage.getItem("utks-sessionid") == null) {
    next({ path: '/login' })
  } else {
    next()
  }
  /*if (localStorage.getItem('utks-sessionid') == null && (to.path != 'login' || to.path != 'logout')) {
    next({
      path: '/login',
      params: { nextUrl: to.fullPath }
    })
  } else {
    //next()
    let sessionid = localStorage.getItem('utks-sessionid')
    console.log("checkin sid : " + sessionid)
    axios
    .post('https://utks.lenoi.net/api/session/checkin?SessionId=' + sessionid)
    .then(response => {
      if(response.data.hasError == false)
        next()
      else 
        next({ path: '/login', params: { nextUrl: to.fullPath }})
    })
    .catch(error => { 
      console.log(error)
      next({ path: '/login', params: { nextUrl: to.fullPath }})
    })
  }
})
*/

export default vRouter



// WEBPACK FOOTER //
// ./src/router/index.js